import React, { useEffect, useState, useContext } from 'react';
import { Table, Pagination, ConfigProvider } from 'antd';
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import moment from 'moment';
import { DataContext } from '../../init/getData';
import toast from 'react-hot-toast';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { TiExport } from "react-icons/ti";
import { BiExport } from "react-icons/bi";
import exportToExcel from '../export/excel';
import ReportModal from '../../components/modals/reportModal';
import StatementReportModal from '../../components/modals/statementReportModal';
import { dateFormatter, dateViewerFormatter } from '../../dynamic/dateFormatter';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';

const SimpleTable = (props) => {

  const { filter, table, refreshTable, columnDefs, data, setData, tableFooter,
    height, getAllData, rowColor, setCheckedArray, selection, api, getExcelData, title, report, reportRef,   onRowClick, statementreport, statementreportRef } = props;

  const { userData, settingData, refCompany } = useContext(DataContext);

  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState({ pagination: { current: 1, pageSize: 100, }, });

  const [showReportModal, setShowReportModal] = useState(false);
  const [showStatementReportModal, setShowStatementReportModal] = useState(false);

  const fetchData = async () => {
    setLoading(true);

    const sortField = tableParams.field;
    const sortDirection = tableParams.order;

    let data = {
      filter: filter,
      startRow: getAllData ? null : (tableParams.pagination.current - 1) * tableParams.pagination.pageSize,
      endRow: getAllData ? null : (tableParams.pagination.current) * tableParams.pagination.pageSize,
      sortField: sortField,
      sortDirection: sortDirection,
    };


    if (filter.search) {
      data.startRow = null;
      data.endRow = null;
    }


    if (tableParams.column) {
      data.sortField = tableParams.field;
      data.sortDirection = tableParams.order == "ascend" ? 'asc' : 'desc';
    }

    await api.get(`/${table}/getall`, { params: data }).then(response => {
      if (!response.data.status) {
        toast.error('Failed to get Data')
      } else {
        setData(response.data);
        setLoading(false);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: response.data.totalRecords,
            showSizeChanger: false,
          },
        });
      }
    })
  };



  const exportDataToExcel = async () => {
    setLoading(true);
    let data = {
      filter: filter,
      startRow: null,
      endRow: null,
    };


    if (tableParams.column) {
      data.sortField = tableParams.field;
      data.sortDirection = tableParams.order == "ascend" ? 'asc' : 'desc';
    }

    await api.get(`/${table}/getall`, { params: data }).then(response => {
      if (!response.data.status) {
        toast.error('Failed to get Data') 
      } else {
        setLoading(false);
        const excelData = getExcelData(response.data.data, response.data.summary);
        exportToExcel(excelData, title);
      }
    })


  };

  const exportToXML = async (data, title) => {
    const zip = new JSZip();

    // Loop through each item and create an XML file
    data.transformedData.forEach((item, index) => {
      const formattedDate = moment(item.date, 'YYYY-MM-DD').format('MM-DD-YYYY');

      let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
      xml += `<zed>\n`;
      xml += `  <no>${'LeVant'}</no>\n`;
      xml += `  <invoice_no>${item.id || ''}</invoice_no>\n`;
      xml += `  <zdate>${formattedDate}</zdate>\n`;
      xml += `  <amount>${numberFormatter(item.total)}</amount>\n`;
      xml += `</zed>\n`;

      // Add each XML file to the zip folder
      zip.file(`Levant-${index + 1}.xml`, xml);
    });

    // Generate the zip file and trigger download
    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${title}.zip`);
    });
  };








  useEffect(() => {
    fetchData();
  }, [tableParams.pagination.current, tableParams.field, tableParams.order, filter, refreshTable]);



  const reportModal = (e) => {
    setShowReportModal(!showReportModal);
  }

  const reportStatementModal = (e) => {
    setShowStatementReportModal(!showStatementReportModal);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,  
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };  



  const customPagination = {
    ...tableParams.pagination,
    itemRender: (current, type, originalElement) => {
      if (type === 'prev') {
        return <IoIosArrowBack size={20} style={{ marginRight: '12px' }} />;
      }
      if (type === 'next') {
        return <IoIosArrowForward size={20} style={{ marginLeft: '12px' }} />;
      }
      return originalElement;
    },
    showTotal: (total, range) => (
      <div style={{ display: 'flex', justifyContent: 'space-between'}}>
        <div>
          {tableFooter}
        </div>

        <div>{`Total:  ${total} items`}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '20px', transform: 'translateX(-50%)'}}>
          <DropdownButton
            drop={'up'}
            title={<BiExport size={25} color={'#2b7b76'} />}
            size={'sm'}
            variant="white"
            className="custom-dropdown-button">
            <Dropdown.Item eventKey="1" onClick={() => exportDataToExcel()}>Excel .xlsx</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item eventKey="2" onClick={() => reportModal()}>Summary .pdf</Dropdown.Item>
            
            {table === 'accountStatement' && (
            <Dropdown.Item eventKey="3" onClick={() => reportStatementModal()}>Report .pdf</Dropdown.Item>
            )}

            {table === 'transaction' && (
              <>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="4" onClick={async () => {
                  setLoading(true);
                  let data = {
                    filter: filter,
                    startRow: null,
                    endRow: null,
                  };

                  if (tableParams.column) {
                    data.sortField = tableParams.field;
                    data.sortDirection = tableParams.order === "ascend" ? 'asc' : 'desc';
                  }

                  await api.get(`/${table}/getall`, { params: data }).then(response => {
                    if (!response.data.status) {
                      toast.error('Failed to get Data');
                    } else {
                      setLoading(false);
                      const xmlData = getExcelData(response.data.data, response.data.summary);
                      exportToXML(xmlData, title); // Now it exports as a zip
                    }
                  });
                }}>XML .zip</Dropdown.Item>

              </>
            )}
          </DropdownButton>
        </div>
      </div>
    ),
  };



  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      if (setCheckedArray) {
        setCheckedArray(selectedRowKeys)
      }
    },
  };

  const handleRowClick = (record) => {
    if (onRowClick) {
      onRowClick(record);
    }
  };



  return (

    <div style={{ userSelect: 'none' }}>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              rowHoverBg: '#e6f4ff',
              headerSortActiveBg: '#00709d',
              headerSortHoverBg: '#00709d',
            },
          },
        }}
      >


        <Table
          className={height ? 'ant_table_mini' : 'ant_table'}
          columns={columnDefs}
          rowSelection={selection ? {
            type: 'checkbox',
            ...rowSelection,
          } : null}
          rowKey={(record) => record.id}
          dataSource={data ? data.data : null}
          loading={loading}
          onChange={handleTableChange}
          scroll={{ y: height ? '60vh' : '67vh' }}
          size="small"
          pagination={customPagination}
          rowClassName={(record, index) => {
            return index % 2 === 0 ? 'even-row' : 'odd-row';
          }}

          onRow={(record) => ({
            onClick: () => handleRowClick(record),
          })}
        />

      </ConfigProvider>

      <ReportModal
        showModal={showReportModal}
        toggleModal={reportModal}
        api={api}
        report={report}
        reportRef={reportRef}
      />

      <StatementReportModal
        showModal={showStatementReportModal}
        toggleModal={reportStatementModal}
        api={api}
        report={statementreport}
        reportRef={statementreportRef}
      />

    </div>
  );
};

export default SimpleTable;
